export const wizardFeatureTranslationJP = {
  WizardListPage: {
    head_title: 'ウィザード一覧',
    add_new: '新規追加',
    detailed: '詳細',
    delete: '削除',
    restore: '復元',
    selection: '選択',
    note: '備考',
    wizard_name: 'ウィザード名',
    target_menu: '対象メニュー',
    warn_confirm_delete_with_invalid_wizard:
      '選択されたウィザードのうち（{{invalid_wizard_names}}）は、対象メニューが存在しているため削除できません。対象メニューを削除してからウィザードを削除してください。<br/>それ以外の選択されたウィザードを削除します。<br/>よろしいですか？',
    warn_alert_delete_with_invalid_wizard:
      '選択されたウィザードのうち（{{invalid_wizard_names}}）は、対象メニューが存在しているため削除できません。対象メニューを削除してからウィザードを削除してください。',
    warn_confirm_delete: '選択されたウィザードを削除します。<br/>よろしいですか？',
    warn_confirm_restore: '選択されたウィザードを復元します。<br/>よろしいですか？',
  },
  WizardDetailModal: {
    head_title: 'ウィザード詳細',
    save: '保存',
    wizard_name: 'ウィザード名',

    japanese: '日本語',
    english: '英語',
    simplified_chinese: '中国語（簡体字）',
    transitional_chinese: '中国語（繁体字）',
    korean: '韓国語',
    vietnamese: 'ベトナム語',

    //intro
    intro: 'イントロ画面',
    active_flg: '有効',
    display_type: '表示タイプ',
    thumb: 'サムネイル画像',
    video: '動画',
    image: '画像',
    text: 'テキスト',

    //outtro
    outtro: 'アウトロ画面',
    outtro_message: 'メッセージ',

    //error messages
    error_message: 'エラーメッセージ',
    warning_required_selection: 'オプション未選択で',

    note: '備考',

    warn_field_required: 'この項目は必須です。',
  },
};
